import { render, staticRenderFns } from "./MediaTabsPanel.vue?vue&type=template&id=67d7112b&scoped=true&"
import script from "./MediaTabsPanel.vue?vue&type=script&lang=js&"
export * from "./MediaTabsPanel.vue?vue&type=script&lang=js&"
import style0 from "./MediaTabsPanel.vue?vue&type=style&index=0&id=67d7112b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d7112b",
  null
  
)

export default component.exports